var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('myHeader'),_vm._v(" "),_c('div',{staticClass:"web-body"},[_c('div',{staticClass:"icp"},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"Responsive image","src":_vm.img,"id":"banner"}})])]),_vm._v(" "),_c('myFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405f26a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icp.vue
// module id = null
// module chunks = 